import React from "react";
import { string, number, array, func, bool } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import SixStories1AdWithTagSearch from "../SixStories1AdWithTagSearch";
import Stories2AdWithLoadMore from "../Stories2AdWithLoadMore";
import DfpAd from "../../dfp-ad";

const NO_OF_STORIES_TO_LOAD = 6;

const SixteenStories3AdWithTagSearchAndLoadMore = ({ collectionSlug, stories, widgetUrl, lang }) => {
  const list = stories.map((story) => story);
  const firstStoriesSet = list.slice(0, 6);
  const remainingStoriesSet = list.map(({ story }) => story).slice(0, 16);

  if (list.length < 0) {
    return null;
  }

  return (
    <div>
      <SixStories1AdWithTagSearch isSectionComponent={true} firstStoriesSet={firstStoriesSet} widgetUrl={widgetUrl} />
      <DfpAd
        adType={lang === "en" ? "EnPalo_ROS_468x60_B1" : "News_468x60_B1"}
        slotId="SixteenStories3AdWithTagSearchAndLoadMore"
      />
      {stories.length > 6 && (
        <LoadMoreCollectionStories
          collectionSlug={collectionSlug}
          template={MoreCollectionStories}
          data={{ stories: remainingStoriesSet }} // passing all the stories and set offSet=16 , since first 16 stories are passed to two components
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      )}
    </div>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading, noMoreStories }) => (
  <Stories2AdWithLoadMore
    list={stories.slice(6, stories.length)} // sliced first 6 stories for the first component and display next 10 stories initally to second component
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD < stories.slice(6, stories.length).length && !noMoreStories}
    className="loadmore-stories"
  />
);

SixteenStories3AdWithTagSearchAndLoadMore.propTypes = {
  accentColor: string,
  numberOfCardsInViewDesktop: number,
  numberOfCardsInViewTablet: number,
  numberOfCardsInViewMobile: number,
  stories: array,
  collectionSlug: string,
  widgetUrl: string,
  lang: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

export default SixteenStories3AdWithTagSearchAndLoadMore;
